export default "{\n    \"sendingText\": \"Enviando\"\n}\n"